import * as _ from 'lodash';
import { fromJS } from 'immutable';
import * as actions from '../actions/workitemsearch';
import { fetchingState } from '@constants';
import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';

const initialState = fromJS({
  resultConfig: [],
  results: { data: [], state: null },
  pagination: {
    count: 0,
    page: 1,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 500, 1000, 5000],
  },
});

const workTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_SEARCH_RESULT_CONFIG[SUCCESS]: {
      return state.setIn(
        ['resultConfig'],
        fromJS(_.get(action, 'data.results', [])),
      );
    }
    case actions.SEARCH_WORK_ITEM[START]: {
      return state
        .setIn(['results', 'state'], fetchingState.FETCHING)
        .setIn(['pagination', 'page'], action.page)
        .setIn(['pagination', 'rowsPerPage'], action.pageSize);
    }
    case actions.SEARCH_WORK_ITEM[SUCCESS]: {
      return state
        .setIn(['results', 'state'], fetchingState.LOADED)
        .setIn(['results', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(
          ['pagination', 'count'],
          _.get(action, 'data.totalWorkItems', 0),
        );
    }
    case actions.SEARCH_WORK_ITEM[ERROR]: {
      return state.setIn(['results', 'state'], fetchingState.ERROR);
    }

    case actions.CHANGE_PAGE: {
      return state.setIn(['pagination', 'page'], action.payload);
    }
    case actions.CHANGE_ROWS_PER_PAGE: {
      return state.setIn(['pagination', 'rowsPerPage'], action.payload);
    }

    case actions.DELETE_WORK_ITEM[SUCCESS]:
      return state
        .setIn(
          ['results', 'data'],
          fromJS([
            ...state
              .getIn(['results', 'data'])
              .toJS()
              .filter(d => d.workItemID !== action.workItemID),
          ]),
        )
        .setIn(
          ['pagination', 'count'],
          state.getIn(['pagination', 'count']) - 1,
        );

    default: {
      return state;
    }
  }
};

export default workTypesReducer;
